import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, nextTick, watch } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableText',
  props: {
    text: {
      type: String,
    },
  },
  setup(__props) {

const props = __props;

  

  const contentRef = ref<HTMLElement | null>(null);
  const isExpanded = ref(false);
  const isTruncated = ref(false);
  let resizeObserver: ResizeObserver | null = null;

  const checkTruncation = async () => {
    await nextTick();
    if (contentRef.value) {
      // Check if content is actually truncated
      const element = contentRef.value;

      if (isExpanded.value) {
        return;
      }

      isTruncated.value = element.scrollHeight > element.clientHeight;
    }
  };

  onMounted(() => {
    checkTruncation();

    if (contentRef.value && typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(() => {
        checkTruncation();
      });
      resizeObserver.observe(contentRef.value);
    }
  });

  onUnmounted(() => {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  });

  watch(() => props.text, () => {
    isExpanded.value = false;
    checkTruncation();
  });

  const toggle = () => {
    isExpanded.value = !isExpanded.value;
  };

return { __sfc: true,props, contentRef, isExpanded, isTruncated, resizeObserver, checkTruncation, toggle }
}

})